<div class="fullPage">
<mat-card class="p-17px-custom" >
  <mat-card-title class="text-center">{{text}}</mat-card-title>
  <mat-card-content>
    <p class="text-center"></p>
  </mat-card-content>
  <br>
  <mat-card-actions class="formWidthLanding text-center" *ngIf="showDropDown">
    <mat-select  placeholder="Select State" class="w-50pct mt-neg1rem text-left" (selectionChange)="selectState($event.value)">
      <mat-option value="KA">Karnataka</mat-option>
      <mat-option value="MP">Madhya Pradesh</mat-option>
      <!-- <mat-option value="AP">Andhra Pradesh</mat-option> -->
    </mat-select>
  </mat-card-actions>
  <mat-card-actions class="text-center" *ngIf="showButtons && !isCoLogin">
    <button mat-raised-button class="button p-2rem" (click)="onfresh()" color="primary">Fresh Applications</button>
    <button mat-raised-button class="button ml-2rem p-2rem" (click)="renewal()" color="primary">Renewal Applications</button>
    <!-- TODO Add Button for SOF Update -->
    <button *ngIf="haveSofUpdateAccess()" mat-raised-button  class="button ml-2rem p-2rem" (click)="onSof()" color="primary">SOF Update</button>
  </mat-card-actions>
  <mat-card-actions class="text-center" *ngIf="isCoLogin">
    <button mat-raised-button class="button mr-2rem p-2rem" (click)="onfresh()" color="primary">Fresh Applications</button>
    <button mat-raised-button class="button mr-2rem p-2rem" (click)="renewal()" color="primary">Renewal Applications</button>
    <button mat-raised-button class="button mr-2rem p-2rem" (click)="onUtilities()" color="primary">Utilities</button>
  </mat-card-actions>
</mat-card>
</div>
